import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import axios from "axios";

const ReelsComponent = () => {
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const fetchReels = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API_BASE_URL}/list-reels`);
        setReels(response.data.reels);
        setError(null);
      } catch (err) {
        // We capture the error but will display a friendly message in render
        setError(err.response?.data?.error || "Failed to fetch reels");
      } finally {
        setLoading(false);
      }
    };

    fetchReels();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-[534px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#D4AF37]"></div>
      </div>
    );
  }

  // UPDATED: Combined Error and Empty state to show a friendly message
  if (error || reels.length === 0) {
    return (
      <div className="flex justify-center items-center h-[534px] w-full bg-gray-50/50 rounded-lg border border-[#D4AF37]/10">
        <div className="text-center">
            <p className="text-gray-400 text-lg font-medium tracking-wide" style={{ fontFamily: "Montserrat, serif" }}>
                No reels available at the moment.
            </p>
            <p className="text-gray-300 text-sm mt-2">Check back later for updates!</p>
        </div>
      </div>
    );
  }

  return (
    <Swiper
      modules={[Autoplay]}
      spaceBetween={24}
      slidesPerView={1}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={true}
      breakpoints={{
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
      }}
      className="w-full"
    >
      {reels.map((reel) => (
        <SwiperSlide key={reel.id} className="flex justify-center">
          <div className="relative w-[300px] h-[534px] rounded-lg overflow-hidden shadow-lg border-2 border-[#D4AF37]/50 hover:border-[#D4AF37] transition-all duration-300">
            <video
              src={reel.video}
              className="w-full h-full object-cover"
              muted
              loop
              playsInline
              autoPlay
            >
              Your browser does not support the video tag.
            </video>
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
            {/* <p className="absolute bottom-4 left-4 text-white text-sm font-medium" style={{ fontFamily: "Montserrat, serif" }}>
              {reel.title}
            </p> */}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ReelsComponent;